import storeConfig from "./config";

export default storeConfig();



// WEBPACK FOOTER //
// ./src/store/index.js